module.exports = __webpack_public_path__ + "static/media/img_hourly_02.aea4bbda.png";